"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /* eslint-disable react-hooks/exhaustive-deps */
const ReactHTMLPicture = (0, _component.default)(() => import("@micado-digital/react-htmlpicture/ReactHTMLPicture"));
const Typography = (0, _component.default)(() => import("@micado-digital/react-ui/components/Typography"));
const Button = (0, _component.default)(() => import("./Button"));
const useStyles = (0, _makeStyles.default)(theme => ({
  root: {
    [theme.breakpoints.up("md")]: {
      display: "grid",
      gridColumnGap: theme.spacing(4),
      gridTemplateColumns: "1fr 1fr",
      gridTemplateRows: "auto"
    },
    [theme.breakpoints.up("lg")]: {
      gridColumnGap: theme.spacing(6)
    }
  },
  rootLeft: {
    "& .mco-imagetext-01__image": {
      [theme.breakpoints.up("md")]: {
        gridColumn: "2 / 3"
      }
    },
    "& .mco-imagetext-01__content": {
      [theme.breakpoints.up("md")]: {
        gridColumn: "1 / 2"
      }
    }
  },
  image: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      gridColumn: "1 / 2",
      gridRow: "1 / -1",
      marginBottom: 0
    },
    "& img": {
      height: "100%",
      width: "100%"
    }
  },
  content: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "column",
      gridColumn: "2 / 3",
      gridRow: "1 / -1"
    }
  },
  title: {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(2)
  },
  text: {
    "& span.hidden": {
      display: "none"
    },
    "& ul": {
      listStyle: "outside",
      margin: theme.spacing(2, 0, 2, 2.5),
      "& li": {
        margin: theme.spacing(0.5, 0)
      }
    },
    "& a": {
      fontWeight: 700
    }
  },
  show: {
    "& span.hidden": {
      display: "block"
    }
  }
}));
const ReactImageText01 = _ref => {
  let {
    addition2: headline,
    alt,
    buttonLabel,
    lang = "de",
    headlineVariant = "h3",
    media,
    mediaFormats,
    mediaPath,
    option: alignment = 0,
    text,
    title: subTitle,
    ButtonProps
  } = _ref;
  const [show, setShow] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const $wrapper = (0, _react.useRef)(null);
  const css = useStyles();
  const handleClick = pathname => {
    if (pathname) {
      navigate(pathname);
    } else {
      return;
    }
  };
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => {
      var _$wrapper$current;
      const $links = $wrapper === null || $wrapper === void 0 || (_$wrapper$current = $wrapper.current) === null || _$wrapper$current === void 0 ? void 0 : _$wrapper$current.querySelectorAll("a:not([target=_blank]):not([href^='mailto:']):not([href^='tel:'])");
      $links === null || $links === void 0 || $links.forEach(link => {
        const pathname = link === null || link === void 0 ? void 0 : link.pathname;
        link === null || link === void 0 || link.addEventListener("click", () => handleClick(pathname));
      });
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.root, "mco-imagetext-01", "mco-imagetext-01__wrapper--".concat(alignment === 0 ? "right" : "left"), {
      [css.rootLeft]: alignment === 1
    }),
    ref: $wrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-imagetext-01__image", css.image),
    style: {
      order: alignment
    }
  }, /*#__PURE__*/_react.default.createElement(ReactHTMLPicture, _extends({
    alt: alt,
    media: media,
    path: mediaPath,
    webpFallback: true
  }, mediaFormats))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.content, "mco-imagetext-01__content")
  }, subTitle && /*#__PURE__*/_react.default.createElement(Typography, {
    className: "mco-imagetext-01__subtitle",
    component: "p",
    variant: "subtitle2"
  }, subTitle), headline && /*#__PURE__*/_react.default.createElement(Typography, {
    className: (0, _clsx.default)(css.title, "mco-imagetext-01__title"),
    dangerouslySetInnerHTML: {
      __html: headline
    },
    variant: headlineVariant
  }), text && /*#__PURE__*/_react.default.createElement(Typography, {
    className: (0, _clsx.default)(css.text, "mco-imagetext-01__text")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)({
      [css.show]: show
    }),
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), !show && text.indexOf("<span class=\"hidden\">") > -1 && /*#__PURE__*/_react.default.createElement(Button, {
    label: buttonLabel,
    lang: lang,
    setShow: setShow,
    ButtonProps: ButtonProps
  }))));
};
ReactImageText01.propTypes = {
  addition2: _propTypes.default.string,
  alt: _propTypes.default.string,
  headlineVariant: _propTypes.default.string,
  media: _propTypes.default.object.isRequired,
  mediaFormats: _propTypes.default.object,
  mediaPath: _propTypes.default.string,
  option: _propTypes.default.number,
  text: _propTypes.default.string,
  title: _propTypes.default.string
};
var _default = exports.default = ReactImageText01;